import React, { useState } from 'react';
import { Typography, Box, Paper, Modal, IconButton, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import EnhancedQuestionRenderer from '../EnhancedQuestionRenderer';

const ExamPreview = ({ exam, open, onClose, inline }) => {
  const [dummyAnswers, setDummyAnswers] = useState({});
  if (!exam || !Array.isArray(exam.sections) || !exam.sections.every(s => Array.isArray(s.questions))) return null;

  let content;
  try {
    content = (
      <Paper elevation={4} style={{ padding: 24, maxWidth: 900, width: '100%', maxHeight: inline ? undefined : '90vh', overflowY: inline ? undefined : 'auto', position: 'relative', fontSize: 13 }}>
        {!inline && onClose && (
          <IconButton onClick={onClose} style={{ position: 'absolute', top: 12, right: 12 }}>
            <CloseIcon />
          </IconButton>
        )}
        <Typography variant="h5" style={{ fontWeight: 700, color: '#004085', textAlign: 'center', marginBottom: 16, fontSize: 18 }}>
          Exam Preview (Candidate View)
        </Typography>
        <Typography variant="h6" style={{ marginBottom: 8, fontSize: 15 }}>{exam.title}</Typography>
        <Typography color="textSecondary" style={{ marginBottom: 16, fontSize: 13 }}>Code: {exam.code} | Timer: {exam.timer} min</Typography>
        {exam.sections.map((section, sIdx) => (
          <Box key={section.id} mb={3}>
            <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#1976d2', marginBottom: 8, fontSize: 14 }}>
              Section {sIdx + 1}: {section.title} (Weightage: {section.weightage}%)
            </Typography>
            {section.questions.map((q, qIdx) => (
              <Box key={q.id} mb={2} style={{ border: '1px solid #e0e0e0', borderRadius: 8, padding: 12 }}>
                <Typography variant="body1" style={{ fontWeight: 500, marginBottom: 8, fontSize: 13 }}>Q{qIdx + 1}:</Typography>
                <EnhancedQuestionRenderer
                  question={q}
                  answer={dummyAnswers[q.id]}
                  onAnswerChange={() => {}}
                  disabled={true}
                  examCode="preview"
                  userId="preview"
                />
              </Box>
            ))}
          </Box>
        ))}
        {!inline && (
          <Box display="flex" justifyContent="center" mt={2}>
            <Button variant="contained" color="primary" onClick={onClose}>Close Preview</Button>
          </Box>
        )}
      </Paper>
    );
  } catch (err) {
    content = <Paper elevation={4} style={{ padding: 24, color: 'red' }}>Error rendering preview: {err.message}</Paper>;
  }

  if (inline) return content;
  return (
    <Modal open={open} onClose={onClose} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {content}
    </Modal>
  );
};

export default ExamPreview; 